
import Vue from 'vue'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'

Vue.use(WechatPlugin)
export default {
name: 'app',
created() {  //页面初始化加载的函数
/*if(!this.rightment){
alert("请用微信打开")
}*/
/* if (!sessionStorage.getItem('encryptToken') || sessionStorage.getItem('encryptToken')=="undefined") {
this.getWeChatCode();
return false
}else {

}*/
/*if(sessionStorage.getItem('encryptToken')){
this.getWxConfig()
}*/
},
computed:{

rightment(){
/*   if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {  //判断iPhone|iPad|iPod|iOS

return "ios"
} else if (/(Android)/i.test(navigator.userAgent)) {   //判断Android
return "Android"                                                  

} else {  //pc
return "pc"
};*/
var u = navigator.userAgent;
var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; 
var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 

var ua = window.navigator.userAgent.toLowerCase();
if (ua.match(/MicroMessenger/i) == 'micromessenger') {
if(isAndroid){
return "android"
}else if(isiOS){
return "ios"
}else{
return "pc"
}
} else {
return false

}
}

},
methods: {
/*获取微信config*/
/* getWxConfig: async function () {
let wxredirect_url= location.href.split('#')[0];
let params = {
url:wxredirect_url
}
const res = await this.$api.get("getWorkWXConfig", params)

if(res.data.code == "0000"){
let wxconfig =res.data.data

Vue.wechat.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: res.data.data.appId, // 必填，公众号的唯一标识
timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
signature: res.data.data.signature,// 必填，签名
jsApiList: ["getBrandWCPayRequest"] 
})
}else{
this.$vux.toast.show({
text: res.data.msg,
type: "warn"
})
}},*/

}
}



// WEBPACK FOOTER //
// ./src/App.vue